// extracted by mini-css-extract-plugin
export var cardFigure = "_7-0";
export var cardImage = "_7-2";
export var cardInner = "_7-1";
export var cardLabel = "_7-3";
export var cardPill = "_7-4";
export var cardPillActive = "_7-6";
export var cardPillSelfServe = "_7-7";
export var cardPillText = "_7-5";
export var pillGlow = "_7-8";
export var pillShimmer = "_7-9";